export default {
  delete_success: 'Registro excluido com sucesso',
  new_success: 'Registro adicionado com sucesso',
  update_success: 'Registro atualizado com sucesso',
  success_change_password: 'Senha alterada com sucesso',
}
